var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Checkbox, CircularProgress, IconButton, Link, Stack, TableBody, TableCell, TableRow, Typography, } from '@mui/material';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'react-redux';
import { Autocomplete, ConfirmDialog, ErrorMessageBox, FallbackComponent } from '../../common';
import { SelectOrCustomField } from '../../common/selectOrCustomField';
import { SHRINKAGE_SUBCATEGORY_TRANS_KEYS, SHRINKAGE_SUBCATEGORY_TYPES, ShrinkageSubcategory, } from '../../wizard/shrinkage/constants';
import { CopyFromLocationDropdown } from '../common/CopyFromLocationDropdown';
import { LocationListPanel } from '../common/LocationListPanel';
import { StepContentPanel } from '../common/StepContentPanel';
import { WizardTable } from '../common/WizardTable';
import { OrgConfigStepContainer } from '../common/stepContainer';
import { usePersistingLocationSelect } from '../common/usePersistingLocationSelect';
import { waitForApiSliceTerminal } from '../common/waitForApiSliceTerminal';
import { MAX_TEXT_LENGTH } from '../constants';
import { OrgConfigWizardContext, useOrgConfigDirtyRegister } from '../context';
import { orgConfigShrinkageSaveApiKey, useConfiguredLocationIds, useCopyShrinkageFromAPI, useLocationsAPI, useSaveShrinkageAPI, useShrinkageConfigAPI, useShrinkageStatusAPI, } from '../selectors';
import { useStaffSettingsConfigAPI } from '../staffSettings/selectors';
import { AddShrinkageModal } from './AddShrinkageModal';
import { CUSTOM_FACTOR_VALUE, PREDEFINED_SHRINKAGE_FACTORS, SHRINKAGE_CATEGORY_IN_OFFICE, SHRINKAGE_CATEGORY_OUT_OF_OFFICE, SHRINKAGE_FACTOR_I18N_KEYS, } from './shrinkageConstants';
var emptyMetricSlice = function () { return ({
    daysPerYear: null,
    hoursPerYear: null,
    percentShrinkage: null,
}); };
var defaultRow = {
    shrinkageCategory: SHRINKAGE_CATEGORY_OUT_OF_OFFICE,
    shrinkageFactor: '',
    shrinkageSubcategory: null,
    isPlanned: false,
    isUnplanned: false,
    planned: null,
    unplanned: null,
};
var allPredefinedSet = new Set(__spreadArray(__spreadArray([], PREDEFINED_SHRINKAGE_FACTORS[SHRINKAGE_CATEGORY_OUT_OF_OFFICE], true), PREDEFINED_SHRINKAGE_FACTORS[SHRINKAGE_CATEGORY_IN_OFFICE], true));
var mergeDisplayKey = function (category, factorName, subcategory) {
    return "".concat(category, "|").concat(factorName, "|").concat(subcategory !== null && subcategory !== void 0 ? subcategory : '');
};
/** Maps API shrinkage config to merged UI rows (exported for unit tests). */
export var configToRows = function (config) {
    var _a;
    if (!((_a = config === null || config === void 0 ? void 0 : config.factors) === null || _a === void 0 ? void 0 : _a.length))
        return [defaultRow];
    var map = new Map();
    for (var _i = 0, _b = config.factors; _i < _b.length; _i++) {
        var f = _b[_i];
        var rawName = f.shrinkageFactor;
        var isCustom = !allPredefinedSet.has(rawName);
        var displayFactor = isCustom ? CUSTOM_FACTOR_VALUE : rawName;
        var customFactorName = isCustom ? rawName : undefined;
        var key = mergeDisplayKey(f.shrinkageCategory, rawName, f.shrinkageSubcategory);
        var row = map.get(key);
        if (!row) {
            row = {
                shrinkageCategory: f.shrinkageCategory,
                shrinkageFactor: displayFactor,
                customFactorName: customFactorName,
                shrinkageSubcategory: f.shrinkageSubcategory,
                isPlanned: false,
                isUnplanned: false,
                planned: null,
                unplanned: null,
            };
            map.set(key, row);
        }
        var metrics = {
            daysPerYear: f.daysPerYear,
            hoursPerYear: f.hoursPerYear,
            percentShrinkage: f.percentShrinkage,
        };
        if (f.shrinkageType === 'planned') {
            row.isPlanned = true;
            row.plannedId = f.id;
            row.planned = metrics;
        }
        else {
            row.isUnplanned = true;
            row.unplannedId = f.id;
            row.unplanned = metrics;
        }
    }
    return Array.from(map.values());
};
export var getFactorName = function (row) { var _a; return row.shrinkageFactor === CUSTOM_FACTOR_VALUE ? (_a = row.customFactorName) !== null && _a !== void 0 ? _a : '' : row.shrinkageFactor; };
export var getSubcategoryLabel = function (row, translate, transKeys) {
    var _a;
    var raw = row.shrinkageSubcategory;
    if (!raw)
        return null;
    if (raw === ShrinkageSubcategory.Custom)
        return (_a = row.customSubcategoryName) !== null && _a !== void 0 ? _a : null;
    var transKey = transKeys[raw];
    if (transKey)
        return translate(transKey, { defaultValue: raw });
    return raw;
};
export var hasFactorSelected = function (row) { var _a; return Boolean(((_a = getFactorName(row)) !== null && _a !== void 0 ? _a : '').trim()); };
var rowDisplayKey = function (r) {
    var _a;
    return mergeDisplayKey(r.shrinkageCategory, getFactorName(r), r.shrinkageSubcategory === ShrinkageSubcategory.Custom ? (_a = r.customSubcategoryName) !== null && _a !== void 0 ? _a : '' : r.shrinkageSubcategory);
};
/** True when the row is partially filled so it must not be omitted from save (expandMergedToModalRows skips incomplete rows). */
export function rowFailsShrinkageCompleteness(row) {
    var _a;
    var factorName = ((_a = getFactorName(row)) !== null && _a !== void 0 ? _a : '').trim();
    var hasSide = row.isPlanned || row.isUnplanned;
    if (row.shrinkageFactor === CUSTOM_FACTOR_VALUE && !factorName)
        return true;
    if (hasSide && !factorName)
        return true;
    if (factorName && !hasSide)
        return true;
    return false;
}
/** Row indices that participate in a duplicate key (same category, factor, subcategory, planned/unplanned). */
function duplicateShrinkageRowIndices(rows) {
    var keyToIndices = new Map();
    rows.forEach(function (row, idx) {
        var _a;
        var factorName = getFactorName(row);
        if (!factorName || !(row.isPlanned || row.isUnplanned))
            return;
        var key = rowDisplayKey(row);
        var list = (_a = keyToIndices.get(key)) !== null && _a !== void 0 ? _a : [];
        list.push(idx);
        keyToIndices.set(key, list);
    });
    var dup = new Set();
    Array.from(keyToIndices.values()).forEach(function (indices) {
        if (indices.length > 1) {
            indices.forEach(function (i) { return dup.add(i); });
        }
    });
    return dup;
}
/** One modal/API row per checked planned/unplanned side. */
export var expandMergedToModalRows = function (rows) {
    var _a, _b, _c;
    var out = [];
    for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
        var r = rows_1[_i];
        var name_1 = getFactorName(r);
        if (!name_1 || (!r.isPlanned && !r.isUnplanned))
            continue;
        if (r.isPlanned) {
            var m = (_a = r.planned) !== null && _a !== void 0 ? _a : emptyMetricSlice();
            out.push(__assign(__assign({}, r), { id: r.plannedId, isPlanned: true, isUnplanned: false, daysPerYear: m.daysPerYear, hoursPerYear: m.hoursPerYear, percentShrinkage: m.percentShrinkage }));
        }
        if (r.isUnplanned) {
            var m = (_c = (_b = r.unplanned) !== null && _b !== void 0 ? _b : r.planned) !== null && _c !== void 0 ? _c : emptyMetricSlice();
            out.push(__assign(__assign({}, r), { id: r.unplannedId, isPlanned: false, isUnplanned: true, daysPerYear: m.daysPerYear, hoursPerYear: m.hoursPerYear, percentShrinkage: m.percentShrinkage }));
        }
    }
    return out;
};
var mergeUpdatedFactorsIntoRows = function (prev, updatedAtomic) {
    return prev.map(function (r) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var k = rowDisplayKey(r);
        var plannedUpd = updatedAtomic.find(function (u) { return rowDisplayKey(u) === k && u.isPlanned && !u.isUnplanned; });
        var unplannedUpd = updatedAtomic.find(function (u) { return rowDisplayKey(u) === k && u.isUnplanned && !u.isPlanned; });
        if (!plannedUpd && !unplannedUpd)
            return r;
        return __assign(__assign({}, r), { plannedId: (_a = plannedUpd === null || plannedUpd === void 0 ? void 0 : plannedUpd.id) !== null && _a !== void 0 ? _a : r.plannedId, unplannedId: (_b = unplannedUpd === null || unplannedUpd === void 0 ? void 0 : unplannedUpd.id) !== null && _b !== void 0 ? _b : r.unplannedId, planned: plannedUpd
                ? {
                    daysPerYear: (_c = plannedUpd.daysPerYear) !== null && _c !== void 0 ? _c : null,
                    hoursPerYear: (_d = plannedUpd.hoursPerYear) !== null && _d !== void 0 ? _d : null,
                    percentShrinkage: (_e = plannedUpd.percentShrinkage) !== null && _e !== void 0 ? _e : null,
                }
                : r.planned, unplanned: unplannedUpd
                ? {
                    daysPerYear: (_f = unplannedUpd.daysPerYear) !== null && _f !== void 0 ? _f : null,
                    hoursPerYear: (_g = unplannedUpd.hoursPerYear) !== null && _g !== void 0 ? _g : null,
                    percentShrinkage: (_h = unplannedUpd.percentShrinkage) !== null && _h !== void 0 ? _h : null,
                }
                : r.unplanned });
    });
};
/** After a save+refetch, reorder newRows to match the display order of currentRows. */
var reorderConfigToMatch = function (currentRows, newRows) {
    var byKey = new Map(newRows.map(function (r) { return [rowDisplayKey(r), r]; }));
    var result = [];
    var used = new Set();
    for (var _i = 0, currentRows_1 = currentRows; _i < currentRows_1.length; _i++) {
        var cur = currentRows_1[_i];
        var key = rowDisplayKey(cur);
        var updated = byKey.get(key);
        if (updated) {
            result.push(updated);
            used.add(key);
        }
    }
    Array.from(byKey.entries()).forEach(function (_a) {
        var key = _a[0], row = _a[1];
        if (!used.has(key))
            result.push(row);
    });
    return result.length > 0 ? result : [defaultRow];
};
export var ShrinkageStep = function () {
    var _a, _b, _c, _d, _e, _f;
    var t = useTranslation('orgConfig', { keyPrefix: 'orgConfigWizard.shrinkageStep' }).t;
    var tShrinkage = useTranslation(['wizard', 'translation']).t;
    var _g = useContext(OrgConfigWizardContext), configVersionId = _g.configVersionId, selectedLocationId = _g.selectedLocationId, setSelectedLocationId = _g.setSelectedLocationId, setBeforeNext = _g.setBeforeNext;
    var store = useStore();
    var locationsData = useLocationsAPI(configVersionId)[0];
    var locationsLoading = locationsData.requesting === true;
    var locations = (_b = (_a = locationsData.data) === null || _a === void 0 ? void 0 : _a.locations) !== null && _b !== void 0 ? _b : [];
    var _h = useShrinkageConfigAPI(selectedLocationId), configData = _h[0], fetchConfig = _h[1];
    var _j = useShrinkageStatusAPI(configVersionId), statusData = _j[0], fetchStatus = _j[1];
    var configuredLocationIds = useConfiguredLocationIds(fetchStatus, statusData);
    var _k = useState({}), localOverrides = _k[0], setLocalOverrides = _k[1];
    useEffect(function () {
        if (!selectedLocationId || configData.requesting)
            return;
        var cfg = configData.data;
        var hasData = !!cfg && cfg.factors.length > 0;
        setLocalOverrides(function (prev) {
            var _a;
            if (prev[selectedLocationId] === hasData)
                return prev;
            return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = hasData, _a));
        });
    }, [selectedLocationId, configData.requesting, configData.data]);
    var getLocationStatus = useCallback(function (id) {
        var override = localOverrides[id];
        if (override !== undefined)
            return override ? 'ok' : 'incomplete';
        return configuredLocationIds.has(id) ? 'ok' : 'incomplete';
    }, [configuredLocationIds, localOverrides]);
    var _l = useSaveShrinkageAPI(selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0), saveData = _l[0], saveConfig = _l[1], clearSaveData = _l[2];
    var _m = useState(null), copySourceId = _m[0], setCopySourceId = _m[1];
    var _o = useCopyShrinkageFromAPI(selectedLocationId !== null && selectedLocationId !== void 0 ? selectedLocationId : 0, copySourceId), copyData = _o[0], doCopy = _o[1], clearCopyData = _o[2];
    var _p = useStaffSettingsConfigAPI(selectedLocationId), staffSettingsData = _p[0], fetchStaffSettings = _p[1];
    var config = configData.data;
    var currentLocation = locations.find(function (l) { return l.id === selectedLocationId; });
    var agentWorkHours = (_c = staffSettingsData.data) === null || _c === void 0 ? void 0 : _c.agent;
    var paidHoursPerDay = (_d = agentWorkHours === null || agentWorkHours === void 0 ? void 0 : agentWorkHours.paidHoursPerDay) !== null && _d !== void 0 ? _d : 0;
    var workingDaysPerYear = (_e = agentWorkHours === null || agentWorkHours === void 0 ? void 0 : agentWorkHours.workingDaysPerYear) !== null && _e !== void 0 ? _e : 0;
    var _q = useState([]), rows = _q[0], setRows = _q[1];
    var preserveOrderRef = useRef(false);
    useEffect(function () {
        if (!selectedLocationId)
            return;
        var hasData = rows.some(function (r) { return r.isPlanned || r.isUnplanned; });
        setLocalOverrides(function (prev) {
            var _a;
            if (prev[selectedLocationId] === hasData)
                return prev;
            return __assign(__assign({}, prev), (_a = {}, _a[selectedLocationId] = hasData, _a));
        });
    }, [selectedLocationId, rows]);
    var _r = useState(false), showIncompleteRowErrorAfterNavigate = _r[0], setShowIncompleteRowErrorAfterNavigate = _r[1];
    var _s = useState(false), addModalOpen = _s[0], setAddModalOpen = _s[1];
    var _t = useState(null), deleteRowIndex = _t[0], setDeleteRowIndex = _t[1];
    var _u = useState(false), clearConfirmOpen = _u[0], setClearConfirmOpen = _u[1];
    var duplicateRowIndices = useMemo(function () { return duplicateShrinkageRowIndices(rows); }, [rows]);
    var incompleteShrinkageError = useMemo(function () {
        for (var _i = 0, rows_2 = rows; _i < rows_2.length; _i++) {
            var row = rows_2[_i];
            if (rowFailsShrinkageCompleteness(row)) {
                return t('incompleteShrinkageRowError', {
                    defaultValue: 'Complete each shrinkage row: choose Planned and/or Unplanned and enter a factor name (including a custom name when you choose Custom).',
                });
            }
        }
        return null;
    }, [rows, t]);
    var modalFactors = useMemo(function () { return expandMergedToModalRows(rows.filter(function (r) { return getFactorName(r) && (r.isPlanned || r.isUnplanned); })); }, [rows]);
    var duplicateShrinkageError = useMemo(function () {
        var seen = new Set();
        for (var _i = 0, rows_3 = rows; _i < rows_3.length; _i++) {
            var row = rows_3[_i];
            var factorName = getFactorName(row);
            if (!factorName || !(row.isPlanned || row.isUnplanned))
                continue;
            var key = rowDisplayKey(row);
            if (seen.has(key)) {
                return t('uniqueShrinkageFactorError', {
                    defaultValue: 'Each shrinkage row must be unique for type, factor, and subcategory. Use Planned and Unplanned on the same row for both.',
                });
            }
            seen.add(key);
        }
        return null;
    }, [rows, t]);
    var predefinedSubcategoryKeys = useMemo(function () { return new Set(SHRINKAGE_SUBCATEGORY_TYPES.filter(function (type) { return type !== ShrinkageSubcategory.Custom; })); }, []);
    var matchSubcategoryKey = useCallback(function (value) {
        if (!value)
            return null;
        if (predefinedSubcategoryKeys.has(value))
            return value;
        for (var _i = 0, SHRINKAGE_SUBCATEGORY_TYPES_1 = SHRINKAGE_SUBCATEGORY_TYPES; _i < SHRINKAGE_SUBCATEGORY_TYPES_1.length; _i++) {
            var type = SHRINKAGE_SUBCATEGORY_TYPES_1[_i];
            if (type === ShrinkageSubcategory.Custom)
                continue;
            if (tShrinkage(SHRINKAGE_SUBCATEGORY_TRANS_KEYS[type], { defaultValue: type }) === value)
                return type;
        }
        return null;
    }, [tShrinkage, predefinedSubcategoryKeys]);
    var subcategoryOptions = useMemo(function () { return __spreadArray(__spreadArray([], SHRINKAGE_SUBCATEGORY_TYPES.filter(function (type) { return type !== ShrinkageSubcategory.Custom; }).map(function (type) { return ({
        id: type,
        name: tShrinkage(SHRINKAGE_SUBCATEGORY_TRANS_KEYS[type], { defaultValue: type }),
    }); }), true), [
        { id: ShrinkageSubcategory.Custom, name: t('addNewSubcategory', { defaultValue: '+ Add New' }) },
    ], false); }, [t, tShrinkage]);
    useEffect(function () {
        setShowIncompleteRowErrorAfterNavigate(false);
    }, [rows]);
    useEffect(function () {
        if (selectedLocationId && configVersionId) {
            fetchConfig();
            fetchStaffSettings();
        }
    }, [selectedLocationId, configVersionId, fetchConfig, fetchStaffSettings]);
    var baselineRowsRef = useRef([]);
    useEffect(function () {
        if (config) {
            var rawRows = configToRows(config);
            var normalizedRows_1 = rawRows.map(function (r) {
                if (r.shrinkageSubcategory && r.shrinkageSubcategory !== ShrinkageSubcategory.Custom) {
                    var key = matchSubcategoryKey(r.shrinkageSubcategory);
                    if (key) {
                        return __assign(__assign({}, r), { shrinkageSubcategory: key });
                    }
                }
                return r;
            });
            baselineRowsRef.current = normalizedRows_1;
            if (preserveOrderRef.current) {
                preserveOrderRef.current = false;
                setRows(function (prev) { return reorderConfigToMatch(prev, normalizedRows_1); });
            }
            else {
                setRows(normalizedRows_1);
            }
        }
    }, [config, matchSubcategoryKey]);
    useEffect(function () {
        if (selectedLocationId != null && !config) {
            setRows([defaultRow]);
            baselineRowsRef.current = [defaultRow];
        }
    }, [selectedLocationId, config]);
    useEffect(function () {
        if (saveData.data) {
            preserveOrderRef.current = true;
            fetchConfig();
            clearSaveData();
        }
    }, [saveData.data, fetchConfig, clearSaveData]);
    useEffect(function () {
        if (copyData.data) {
            fetchConfig();
            clearCopyData();
            setCopySourceId(null);
        }
    }, [copyData.data, fetchConfig, clearCopyData]);
    useEffect(function () {
        if (copySourceId && selectedLocationId) {
            doCopy();
        }
    }, [copySourceId, selectedLocationId, doCopy]);
    var handleCopyFrom = useCallback(function (sourceLocationId) {
        setCopySourceId(sourceLocationId);
    }, []);
    var handleClear = useCallback(function () {
        setRows([defaultRow]);
    }, []);
    var updateRow = useCallback(function (index, updates) {
        setRows(function (prev) {
            var next = __spreadArray([], prev, true);
            next[index] = __assign(__assign({}, next[index]), updates);
            if (updates.shrinkageCategory) {
                next[index].shrinkageFactor = '';
                next[index].shrinkageSubcategory = null;
                next[index].customSubcategoryName = undefined;
                next[index].plannedId = undefined;
                next[index].unplannedId = undefined;
                next[index].planned = null;
                next[index].unplanned = null;
                next[index].isPlanned = false;
                next[index].isUnplanned = false;
            }
            return next;
        });
    }, []);
    var addRow = useCallback(function () {
        setRows(function (prev) { return __spreadArray(__spreadArray([], prev, true), [__assign({}, defaultRow)], false); });
    }, []);
    var removeRow = useCallback(function (index) {
        setRows(function (prev) {
            var next = prev.filter(function (_, i) { return i !== index; });
            return next.length === 0 ? [__assign({}, defaultRow)] : next;
        });
    }, []);
    var checkIsDirty = useCallback(function () {
        return JSON.stringify(rows) !== JSON.stringify(baselineRowsRef.current);
    }, [rows]);
    useOrgConfigDirtyRegister(checkIsDirty);
    var persistShrinkage = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var factors, payload, saveKey;
        return __generator(this, function (_a) {
            if (incompleteShrinkageError) {
                setShowIncompleteRowErrorAfterNavigate(true);
                return [2 /*return*/, false];
            }
            if (duplicateShrinkageError) {
                return [2 /*return*/, false];
            }
            if (!selectedLocationId)
                return [2 /*return*/, true];
            if (!checkIsDirty()) {
                return [2 /*return*/, true];
            }
            factors = expandMergedToModalRows(rows).map(function (r) {
                var _a, _b, _c, _d, _e;
                var shrinkageSubcategory = null;
                if (r.shrinkageSubcategory === ShrinkageSubcategory.Custom) {
                    shrinkageSubcategory = (_a = r.customSubcategoryName) !== null && _a !== void 0 ? _a : null;
                }
                else if (r.shrinkageSubcategory) {
                    shrinkageSubcategory = tShrinkage((_b = SHRINKAGE_SUBCATEGORY_TRANS_KEYS[r.shrinkageSubcategory]) !== null && _b !== void 0 ? _b : r.shrinkageSubcategory, {
                        defaultValue: r.shrinkageSubcategory,
                    });
                }
                return {
                    id: r.id,
                    shrinkageCategory: r.shrinkageCategory,
                    shrinkageFactor: getFactorName(r),
                    shrinkageSubcategory: shrinkageSubcategory,
                    shrinkageType: r.isPlanned ? 'planned' : 'unplanned',
                    daysPerYear: (_c = r.daysPerYear) !== null && _c !== void 0 ? _c : null,
                    hoursPerYear: (_d = r.hoursPerYear) !== null && _d !== void 0 ? _d : null,
                    percentShrinkage: (_e = r.percentShrinkage) !== null && _e !== void 0 ? _e : null,
                };
            });
            payload = { factors: factors };
            saveKey = orgConfigShrinkageSaveApiKey(selectedLocationId);
            return [2 /*return*/, waitForApiSliceTerminal(store, saveKey, function () { return saveConfig(payload); })];
        });
    }); }, [
        checkIsDirty,
        duplicateShrinkageError,
        incompleteShrinkageError,
        rows,
        saveConfig,
        selectedLocationId,
        store,
        tShrinkage,
    ]);
    useEffect(function () {
        setBeforeNext(persistShrinkage);
        return function () { return setBeforeNext(null); };
    }, [setBeforeNext, persistShrinkage]);
    var _v = usePersistingLocationSelect({
        selectedLocationId: selectedLocationId,
        setSelectedLocationId: setSelectedLocationId,
        persistCurrent: persistShrinkage,
    }), onSelectLocation = _v.onSelectLocation, isPersistingSelection = _v.isPersistingSelection;
    if (locations.length === 0) {
        if (locationsLoading) {
            return (_jsxs(Box, __assign({ sx: { display: 'flex', alignItems: 'center', gap: 2 } }, { children: [_jsx(CircularProgress, { size: 24 }), _jsx(Typography, __assign({ color: "text.secondary" }, { children: t('loadingLocations', { defaultValue: 'Loading locations…' }) }))] })));
        }
        return (_jsx(Typography, __assign({ color: "text.secondary" }, { children: t('addLocationBeforeShrinkage', {
                defaultValue: 'Add at least one location in Step 1 before configuring shrinkage.',
            }) })));
    }
    var shrinkageForm = (_jsxs(StepContentPanel, __assign({ title: t('sectionTitle', { defaultValue: 'Shrinkage' }), description: t('shrinkageInstruction', {
            defaultValue: 'Enter the planned amount of shrinkage for each agent below.',
        }), action: _jsx(CopyFromLocationDropdown, { locations: locations, currentLocationId: selectedLocationId, onCopy: handleCopyFrom, onClear: function () { return setClearConfirmOpen(true); }, disabled: !!configData.requesting }) }, { children: [_jsxs(Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "space-between", sx: { mb: 2 } }, { children: [_jsx(Typography, __assign({ variant: "h3" }, { children: t('shrinkageTableTitle', { defaultValue: 'Shrinkage factors' }) })), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return setAddModalOpen(true); }, disabled: Boolean(incompleteShrinkageError) || Boolean(duplicateShrinkageError) || modalFactors.length === 0 }, { children: t('addShrinkage', { defaultValue: 'ADD SHRINKAGE' }) }))] })), _jsx(WizardTable, __assign({ headers: _jsxs(_Fragment, { children: [_jsx(TableCell, __assign({ sx: { minWidth: '12rem' } }, { children: t('type', { defaultValue: 'Type' }) })), _jsx(TableCell, { children: t('shrinkageFactor', { defaultValue: 'Shrinkage Factor' }) }), _jsx(TableCell, { children: t('subcategory', { defaultValue: 'Subcategory (optional)' }) }), _jsx(TableCell, __assign({ align: "center", sx: { width: '10%' } }, { children: t('planned', { defaultValue: 'Planned' }) })), _jsx(TableCell, __assign({ align: "center", sx: { width: '10%' } }, { children: t('unplanned', { defaultValue: 'Unplanned' }) })), _jsx(TableCell, { width: 50, align: "center" })] }) }, { children: _jsx(TableBody, { children: rows.map(function (row, idx) {
                        var _a, _b;
                        var factorsForCategory = row.shrinkageCategory === SHRINKAGE_CATEGORY_OUT_OF_OFFICE
                            ? PREDEFINED_SHRINKAGE_FACTORS[SHRINKAGE_CATEGORY_OUT_OF_OFFICE]
                            : PREDEFINED_SHRINKAGE_FACTORS[SHRINKAGE_CATEGORY_IN_OFFICE];
                        var isCustom = row.shrinkageFactor === CUSTOM_FACTOR_VALUE;
                        var rawSubcategory = row.shrinkageSubcategory;
                        var matchedSubcategoryKey = matchSubcategoryKey(rawSubcategory);
                        var isCustomSubcategory = rawSubcategory === ShrinkageSubcategory.Custom ||
                            (rawSubcategory != null && rawSubcategory !== '' && matchedSubcategoryKey === null);
                        var customSubcategoryFallback = rawSubcategory === ShrinkageSubcategory.Custom ? '' : rawSubcategory !== null && rawSubcategory !== void 0 ? rawSubcategory : '';
                        var customSubcategoryValue = isCustomSubcategory
                            ? (_a = row.customSubcategoryName) !== null && _a !== void 0 ? _a : customSubcategoryFallback
                            : '';
                        var rowKey = "row-".concat(idx);
                        var rowHasDuplicateError = Boolean(duplicateShrinkageError) && duplicateRowIndices.has(idx);
                        var rowHasIncompleteError = showIncompleteRowErrorAfterNavigate && rowFailsShrinkageCompleteness(row);
                        var rowHasValidationError = rowHasDuplicateError || rowHasIncompleteError;
                        return (_jsxs(TableRow, { children: [_jsx(TableCell, __assign({ sx: { minWidth: '12rem' } }, { children: _jsx(Autocomplete, { options: [
                                            {
                                                id: SHRINKAGE_CATEGORY_OUT_OF_OFFICE,
                                                name: t('outOfOffice', { defaultValue: 'Out-of-office' }),
                                            },
                                            { id: SHRINKAGE_CATEGORY_IN_OFFICE, name: t('inOffice', { defaultValue: 'In-office' }) },
                                        ], size: "small", fullWidth: true, error: rowHasValidationError, value: row.shrinkageCategory, onChange: function (v) { return v && updateRow(idx, { shrinkageCategory: v }); } }) })), _jsx(TableCell, __assign({ sx: { width: '20rem' } }, { children: _jsx(SelectOrCustomField, { isCustom: isCustom, name: "shrinkageFactor-".concat(idx), value: row.shrinkageFactor, options: factorsForCategory.map(function (f) { return ({
                                            id: f,
                                            name: t("factors.".concat(SHRINKAGE_FACTOR_I18N_KEYS[f]), { defaultValue: f }),
                                        }); }), onChange: function (v) { return updateRow(idx, { shrinkageFactor: v !== null && v !== void 0 ? v : '' }); }, onSelectChange: function (v) { return updateRow(idx, { shrinkageFactor: v !== null && v !== void 0 ? v : '' }); }, customName: "customFactorName-".concat(idx), customValue: (_b = row.customFactorName) !== null && _b !== void 0 ? _b : '', onCustomChange: function (v) {
                                            return updateRow(idx, {
                                                shrinkageFactor: v ? CUSTOM_FACTOR_VALUE : '',
                                                customFactorName: v || undefined,
                                            });
                                        }, customPlaceholder: t('customFactorPlaceholder', { defaultValue: 'Enter custom factor' }), defaultValue: "", placeholder: t('selectFactor', { defaultValue: 'Select a shrinkage factor' }), maxLength: MAX_TEXT_LENGTH, error: rowHasValidationError }) })), _jsx(TableCell, __assign({ sx: { width: '20rem' } }, { children: _jsx(SelectOrCustomField, { disableClearable: false, isCustom: isCustomSubcategory, name: "subcategory-".concat(idx), value: isCustomSubcategory ? ShrinkageSubcategory.Custom : matchedSubcategoryKey !== null && matchedSubcategoryKey !== void 0 ? matchedSubcategoryKey : '', options: subcategoryOptions, onChange: function (v) {
                                            return updateRow(idx, { shrinkageSubcategory: v !== null && v !== void 0 ? v : null, customSubcategoryName: undefined });
                                        }, onSelectChange: function (v) {
                                            return updateRow(idx, { shrinkageSubcategory: v !== null && v !== void 0 ? v : null, customSubcategoryName: undefined });
                                        }, customName: "customSubcategory-".concat(idx), customValue: customSubcategoryValue, onCustomChange: function (v) {
                                            return updateRow(idx, {
                                                shrinkageSubcategory: v ? ShrinkageSubcategory.Custom : '',
                                                customSubcategoryName: v || undefined,
                                            });
                                        }, customPlaceholder: t('customSubcategoryPlaceholder', { defaultValue: 'Enter custom subcategory' }), defaultValue: "", placeholder: t('subcategoryPlaceholder', { defaultValue: 'Select a subcategory' }), maxLength: MAX_TEXT_LENGTH, error: rowHasValidationError }) })), _jsx(TableCell, __assign({ align: "center" }, { children: _jsx(Checkbox, { checked: row.isPlanned, onChange: function (e) {
                                            var checked = e.target.checked;
                                            setRows(function (prev) {
                                                var _a, _b;
                                                var next = __spreadArray([], prev, true);
                                                var cur = next[idx];
                                                next[idx] = checked
                                                    ? __assign(__assign({}, cur), { isPlanned: true, planned: (_b = (_a = cur.planned) !== null && _a !== void 0 ? _a : cur.unplanned) !== null && _b !== void 0 ? _b : emptyMetricSlice() }) : __assign(__assign({}, cur), { isPlanned: false, planned: null, plannedId: undefined });
                                                return next;
                                            });
                                        } }) })), _jsx(TableCell, __assign({ align: "center" }, { children: _jsx(Checkbox, { checked: row.isUnplanned, onChange: function (e) {
                                            var checked = e.target.checked;
                                            setRows(function (prev) {
                                                var _a, _b;
                                                var next = __spreadArray([], prev, true);
                                                var cur = next[idx];
                                                next[idx] = checked
                                                    ? __assign(__assign({}, cur), { isUnplanned: true, unplanned: (_b = (_a = cur.unplanned) !== null && _a !== void 0 ? _a : cur.planned) !== null && _b !== void 0 ? _b : emptyMetricSlice() }) : __assign(__assign({}, cur), { isUnplanned: false, unplanned: null, unplannedId: undefined });
                                                return next;
                                            });
                                        } }) })), _jsx(TableCell, __assign({ align: "center", sx: { p: 0 } }, { children: _jsx(IconButton, __assign({ size: "small", onClick: function () { return setDeleteRowIndex(idx); }, "aria-label": "delete", sx: {
                                            color: function (theme) { return theme.palette.text.primary; },
                                            '&:hover': {
                                                color: function (theme) { return theme.palette.text.primary; },
                                                backgroundColor: function (theme) { return theme.palette.action.hover; },
                                            },
                                        } }, { children: _jsx(FontAwesomeIcon, { icon: "trash-can" }) })) }))] }, rowKey));
                    }) }) })), duplicateShrinkageError && (_jsx(Typography, __assign({ color: "error", variant: "body2" }, { children: duplicateShrinkageError }))), showIncompleteRowErrorAfterNavigate && incompleteShrinkageError && (_jsx(Typography, __assign({ color: "error", variant: "body2" }, { children: incompleteShrinkageError }))), _jsx(Link, __assign({ component: "button", onClick: addRow, sx: { mt: 1, cursor: 'pointer', alignSelf: 'flex-start' } }, { children: t('addShrinkageFactor', { defaultValue: '+ Add shrinkage factor' }) }))] })));
    return (_jsxs(_Fragment, { children: [_jsx(ErrorMessageBox, { errors: [configData.error, saveData.error, copyData.error] }), _jsx(OrgConfigStepContainer, __assign({ leftContent: _jsx(LocationListPanel, { allLocations: locations, selectedLocationId: selectedLocationId, onSelectLocation: onSelectLocation, getLocationStatus: getLocationStatus }) }, { children: selectedLocationId ? (shrinkageForm) : (_jsx(FallbackComponent, { children: _jsx(Box, __assign({ sx: { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 300 } }, { children: _jsx(Typography, __assign({ color: "text.secondary" }, { children: t('selectLocation', {
                                defaultValue: 'Select a location to configure shrinkage.',
                            }) })) })) })) })), _jsx(ConfirmDialog, { open: deleteRowIndex !== null, onClose: function () { return setDeleteRowIndex(null); }, title: t('deleteShrinkageFactorTitle', { defaultValue: 'Delete shrinkage factor?' }), message: deleteRowIndex === null
                    ? ''
                    : t('deleteShrinkageFactorMessage', {
                        defaultValue: 'Are you sure you want to delete this shrinkage factor? This cannot be undone.',
                    }), onConfirm: function () {
                    if (deleteRowIndex !== null) {
                        removeRow(deleteRowIndex);
                        setDeleteRowIndex(null);
                    }
                } }), _jsx(ConfirmDialog, { open: clearConfirmOpen, onClose: function () { return setClearConfirmOpen(false); }, title: t('clearShrinkageDataTitle', { defaultValue: 'Clear shrinkage data?' }), message: t('clearShrinkageDataMessage', {
                    defaultValue: 'Are you sure you want to clear all shrinkage data for this location?',
                }), onConfirm: function () {
                    handleClear();
                    setClearConfirmOpen(false);
                } }), _jsx(FallbackComponent, { requesting: !!configData.requesting || !!saveData.requesting || isPersistingSelection, overlay: true }), _jsx(AddShrinkageModal, { open: addModalOpen, onClose: function () { return setAddModalOpen(false); }, locationName: (_f = currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.locationName) !== null && _f !== void 0 ? _f : '', locationId: currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.id, paidHoursPerDay: paidHoursPerDay, workingDaysPerYear: workingDaysPerYear, factors: modalFactors, onSave: function (updatedFactors) {
                    setRows(function (prev) { return mergeUpdatedFactorsIntoRows(prev, updatedFactors); });
                    setAddModalOpen(false);
                } })] }));
};
